module.exports = __webpack_public_path__ + "img/Wellness.4b7987de.svg";